import { createRoot } from 'react-dom/client';
import '@fontsource/poppins/400.css'; 
import '@fontsource/poppins/500.css'; 
import '@fontsource/poppins/600.css';
import './styles/index.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CustomNavigate from './components/CustomNavigate';
import DashboardLayout from "./layouts/dashboard";
import AuthLayout from "./layouts/auth";
import { Toaster } from 'react-hot-toast';
import MobileWarning from "./components/layout/MobileWarning";
import useIsMobile from "./hooks/useIsMobile";
import { ClipLoader } from 'react-spinners';
import useAuth from './hooks/useAuth';
import useCompany from './hooks/useCompany';
import { useEffect } from 'react';
import AdminLayout from './layouts/admin';


const App = () => {
  const isMobile = useIsMobile();
  const { isPending } = useAuth()
  const { isCompaniesPending, isActiveCompanyPending, activeCompany, companies, selectCompany } = useCompany();
  const companyList = Array.isArray(companies) ? companies : [];

  useEffect(() => {
    if(isPending || isCompaniesPending || isActiveCompanyPending) return;
    if(!activeCompany) return localStorage.removeItem('activeCompanyId');
    localStorage.setItem('activeCompanyId', activeCompany?.id);
  }, [activeCompany, isPending, isCompaniesPending, isActiveCompanyPending]);

  useEffect(() => {
    if(isPending || isCompaniesPending || isActiveCompanyPending) return;
    const storedCompanyId = localStorage.getItem('activeCompanyId');
    if(companyList.length > 0 && !activeCompany) {
      if(storedCompanyId) {
        const companyExists = companyList.some(company => company.id === storedCompanyId);
        if(companyExists) {
          selectCompany(storedCompanyId);
        } else {
          localStorage.removeItem('activeCompanyId');
          selectCompany(companyList[0].id);
        }
      } else {
        selectCompany(companyList[0].id);
      }
    }
  }, [
    companyList,
    activeCompany,
    isPending,
    isCompaniesPending,
    isActiveCompanyPending,
    selectCompany,
  ]);

  if (isMobile) {
    return <MobileWarning />;
  }

  if (isPending || isCompaniesPending || isActiveCompanyPending) return <div className="flex items-center justify-center w-full h-screen">
    <ClipLoader />
  </div>

  return (<BrowserRouter>
    <Routes>
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/dashboard/*" element={<DashboardLayout />} />
      <Route path="/admin/*" element={<AdminLayout />} />
      <Route path="*" element={<CustomNavigate to="/auth" />} />
    </Routes>
    <Toaster />
  </BrowserRouter>);
};

createRoot(document.getElementById("root")).render(<App />);
